// actions
import { Actions } from '../actionTypes/actionTypes';
import { initActionTypes } from '@makemydeal/dr-shared-store';

// types
import type { DealValidationState } from './types';

const initialState: DealValidationState = {
    valid: true,
    missingFields: []
};

export const dealValidation = (state: DealValidationState = initialState, action: any): DealValidationState => {
    const { payload, type } = action;

    switch (type) {
        case initActionTypes.INIT_PENCIL_SUCCESS: {
            const validation = payload?.deal?.validation;
            if (validation) {
                return {
                    valid: validation.valid,
                    missingFields: validation.missingFields
                };
            }
            return state;
        }

        // BFF returns the updated deal (with validation) in the response, use it as the source of truth.
        case Actions.UPDATE_DEAL_SUCCESS: {
            const validation = payload?.data?.deal?.validation;
            if (validation) {
                return {
                    valid: validation.valid,
                    missingFields: validation.missingFields
                };
            }
            return state;
        }

        // Deal refresh (GTL / websocket-driven reload) — the fetch response carries validation
        // alongside the deal, so it is as authoritative as init's.
        case Actions.FETCH_DEAL_SUCCESS: {
            const validation = payload?.data?.validation;
            if (validation) {
                return {
                    valid: validation.valid,
                    missingFields: validation.missingFields ?? []
                };
            }
            return state;
        }

        default:
            return state;
    }
};
